import { PLAN_TIER } from '@app/constant/plan-tier';
import { UNLIMITED_TRANSFER_LIMIT } from '@app/constant/sizes';

import helper from '@app/helper';

export function userNeedsTips(user) {
  const isNotLoggedIn = !user || !user.loggedIn;
  const hasPlusCookie = helper.getWTPlus() === 1;
  const hasNotSentTooManyTransfers = helper.getWTSent() < 5;

  return isNotLoggedIn && hasPlusCookie && hasNotSentTooManyTransfers;
}

export function userHasPlusTier(user) {
  return !!user && user.planTier === PLAN_TIER.PLUS;
}

export function userHasFreeTier(user) {
  return !!user && user.planTier === PLAN_TIER.FREE;
}

export function isLoggedInPlusUser(user) {
  return !!user && user.loggedIn && userHasPlusTier(user);
}

export function isLoggedInFreeUser(user) {
  return !!user && user.loggedIn && userHasFreeTier(user);
}

export function isLoggedOutOrFreeUser(user) {
  return !user || !user.loggedIn || userHasFreeTier(user);
}

export function isLoggedInWithUnlimitedTransfer(user) {
  return (
    !!user &&
    user.loggedIn &&
    !!user.rules &&
    user.rules.transferLimit === UNLIMITED_TRANSFER_LIMIT
  );
}
